import { ListSingleSelectOption } from '../../../../../components/DealerPage/components/Filters/ListSingleSelect/ListSingleSelect';
import { RadioTabs } from '../../../../../components/Toolkit/Inputs/RadioTabs';

export interface IListSingleSelectTagProps {
  name: string;
  label: string;
  value: string;
  options: ListSingleSelectOption[];
  onChange: (value: string) => void;
  className?: string;
}

function ListSingleSelectTag(props: IListSingleSelectTagProps) {
  const { options, label, name, className, onChange, value } = props;
  return (
    <>
      {options && (
        <RadioTabs
          value={value}
          name={name}
          onChange={onChange}
          tabLabel={label}
          options={options.map(({ value, label }) => ({
            value,
            displayValue: label,
          }))}
          className={className}
        />
      )}
    </>
  );
}

export { ListSingleSelectTag };
